// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@300;400;600&family=Archivo:wght@400;500;600&display=swap');*/

:root {
  --color-ink: #1a1a1a;
  --color-paper: rgba( 0, 0, 0, 0.8);
  --color-accent: #d4380d;
  --color-border: #e0e0dc;
  --color-hover: #f5f5f2;
  --color-shadow: rgba(26, 26, 26, 0.08);
  --font-display: 'Crimson Pro', Georgia, serif;
  --font-body: 'Archivo', -apple-system, sans-serif;
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.excel-uploader-container {
  min-height: 100vh;
  background: var(--color-paper);
  padding: 3rem 2rem;
  font-family: var(--font-body);
  color: var(--color-ink);
  border: 1px solid red;
  width: 100%;
  height: 80%;
  max-height: 80%;
}

/* Drop Zone Styles */
.drop-zone {
  max-width: 720px;
  margin: 0 auto;
  border: 2px dashed var(--color-border);
  border-radius: 16px;
  padding: 4rem 2rem;
  text-align: center;
  transition: var(--transition);
  background: white;
  position: relative;
  overflow: hidden;
}

.drop-zone::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(212, 56, 13, 0.03) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.6s ease;
  pointer-events: none;
}

.drop-zone:hover::before,
.drop-zone.dragging::before {
  opacity: 1;
}

.drop-zone:hover {
  border-color: var(--color-accent);
  box-shadow: 0 8px 32px var(--color-shadow);
  transform: translateY(-2px);
}

.drop-zone.dragging {
  border-color: var(--color-accent);
  background: linear-gradient(135deg, rgba(212, 56, 13, 0.05) 0%, rgba(212, 56, 13, 0.02) 100%);
  box-shadow: 0 12px 48px rgba(212, 56, 13, 0.15);
  transform: scale(1.02);
}

.drop-zone-content {
  position: relative;
  z-index: 1;
}

.upload-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 1.5rem;
  color: var(--color-accent);
  opacity: 0.9;
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.drop-zone-title {
  font-family: var(--font-display);
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.drop-zone-subtitle {
  font-size: 1rem;
  color: #666;
  margin-bottom: 2rem;
  font-weight: 400;
}

.file-input {
  display: none;
}

.browse-button {
  display: inline-block;
  padding: 0.875rem 2rem;
  background: var(--color-ink);
  color: white;
  border: none;
  border-radius: 8px;
  font-family: var(--font-body);
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  letter-spacing: 0.01em;
  box-shadow: 0 4px 12px rgba(26, 26, 26, 0.12);
}

.browse-button:hover {
  background: var(--color-accent);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 56, 13, 0.25);
}

.file-format-hint {
  margin-top: 1.5rem;
  font-size: 0.875rem;
  color: #999;
  font-weight: 400;
}

/* Spreadsheet Viewer Styles */
.spreadsheet-viewer {
  max-width: 1400px;
  margin: 0 auto;
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 2rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px var(--color-shadow);
  flex-wrap: wrap;
  gap: 1rem;
}

.file-info {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.file-icon {
  width: 40px;
  height: 40px;
  color: var(--color-accent);
  flex-shrink: 0;
}

.file-name {
  font-family: var(--font-display);
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 0.25rem;
  letter-spacing: -0.01em;
}

.sheet-count {
  font-size: 0.875rem;
  color: #666;
  font-weight: 400;
}

.reset-button {
  padding: 0.75rem 1.5rem;
  background: transparent;
  color: var(--color-ink);
  border: 1.5px solid var(--color-border);
  border-radius: 8px;
  font-family: var(--font-body);
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  letter-spacing: 0.01em;
}

.reset-button:hover {
  background: var(--color-ink);
  color: white;
  border-color: var(--color-ink);
  transform: translateY(-1px);
}

/* Sheet Tabs */
.sheet-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.sheet-tab {
  padding: 0.625rem 1.25rem;
  background: white;
  color: #666;
  border: 1.5px solid var(--color-border);
  border-radius: 8px;
  font-family: var(--font-body);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition);
  letter-spacing: 0.01em;
}

.sheet-tab:hover {
  background: var(--color-hover);
  border-color: #ccc;
}

.sheet-tab.active {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
  box-shadow: 0 2px 8px rgba(212, 56, 13, 0.2);
}

/* Table Container */
.table-container {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px var(--color-shadow);
  border: 1px solid var(--color-border);
}

.spreadsheet-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
  overflow-x: auto;
  display: block;
}

.spreadsheet-table tbody {
  display: table;
  width: 100%;
}

.spreadsheet-table th {
  background: linear-gradient(180deg, #f8f8f6 0%, #f0f0ee 100%);
  color: var(--color-ink);
  font-family: var(--font-body);
  font-weight: 600;
  padding: 1rem 1.25rem;
  text-align: left;
  border-bottom: 2px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 10;
  letter-spacing: 0.02em;
  font-size: 0.875rem;
  text-transform: uppercase;
}

.spreadsheet-table td {
  padding: 0.875rem 1.25rem;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-ink);
  font-family: var(--font-body);
  font-weight: 400;
  transition: background-color 0.15s ease;
}

.spreadsheet-table tr:hover td {
  background: var(--color-hover);
}

.spreadsheet-table tr:last-child td {
  border-bottom: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .excel-uploader-container {
    padding: 2rem 1rem;
  }

  .drop-zone {
    padding: 3rem 1.5rem;
  }

  .drop-zone-title {
    font-size: 1.5rem;
  }

  .viewer-header {
    padding: 1.5rem;
  }

  .file-name {
    font-size: 1.25rem;
  }

  .spreadsheet-table th,
  .spreadsheet-table td {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
}

/* Smooth scrollbar for table */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: var(--color-hover);
}

.table-container::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #999;
}

`, "",{"version":3,"sources":["webpack://./src/Excel.css"],"names":[],"mappings":"AAAA,qIAAqI;;AAErI;EACE,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,6CAA6C;EAC7C,iDAAiD;EACjD,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,cAAc;EACd,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,6FAA6F;EAC7F,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6DAA6D;EAC7D,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA,+BAA+B;AAC/B;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/*@import url('https://fonts.googleapis.com/css2?family=Crimson+Pro:wght@300;400;600&family=Archivo:wght@400;500;600&display=swap');*/\n\n:root {\n  --color-ink: #1a1a1a;\n  --color-paper: rgba( 0, 0, 0, 0.8);\n  --color-accent: #d4380d;\n  --color-border: #e0e0dc;\n  --color-hover: #f5f5f2;\n  --color-shadow: rgba(26, 26, 26, 0.08);\n  --font-display: 'Crimson Pro', Georgia, serif;\n  --font-body: 'Archivo', -apple-system, sans-serif;\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.excel-uploader-container {\n  min-height: 100vh;\n  background: var(--color-paper);\n  padding: 3rem 2rem;\n  font-family: var(--font-body);\n  color: var(--color-ink);\n  border: 1px solid red;\n  width: 100%;\n  height: 80%;\n  max-height: 80%;\n}\n\n/* Drop Zone Styles */\n.drop-zone {\n  max-width: 720px;\n  margin: 0 auto;\n  border: 2px dashed var(--color-border);\n  border-radius: 16px;\n  padding: 4rem 2rem;\n  text-align: center;\n  transition: var(--transition);\n  background: white;\n  position: relative;\n  overflow: hidden;\n}\n\n.drop-zone::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle, rgba(212, 56, 13, 0.03) 0%, transparent 70%);\n  opacity: 0;\n  transition: opacity 0.6s ease;\n  pointer-events: none;\n}\n\n.drop-zone:hover::before,\n.drop-zone.dragging::before {\n  opacity: 1;\n}\n\n.drop-zone:hover {\n  border-color: var(--color-accent);\n  box-shadow: 0 8px 32px var(--color-shadow);\n  transform: translateY(-2px);\n}\n\n.drop-zone.dragging {\n  border-color: var(--color-accent);\n  background: linear-gradient(135deg, rgba(212, 56, 13, 0.05) 0%, rgba(212, 56, 13, 0.02) 100%);\n  box-shadow: 0 12px 48px rgba(212, 56, 13, 0.15);\n  transform: scale(1.02);\n}\n\n.drop-zone-content {\n  position: relative;\n  z-index: 1;\n}\n\n.upload-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 1.5rem;\n  color: var(--color-accent);\n  opacity: 0.9;\n  animation: float 3s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-8px); }\n}\n\n.drop-zone-title {\n  font-family: var(--font-display);\n  font-size: 2rem;\n  font-weight: 400;\n  margin-bottom: 0.5rem;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.drop-zone-subtitle {\n  font-size: 1rem;\n  color: #666;\n  margin-bottom: 2rem;\n  font-weight: 400;\n}\n\n.file-input {\n  display: none;\n}\n\n.browse-button {\n  display: inline-block;\n  padding: 0.875rem 2rem;\n  background: var(--color-ink);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-family: var(--font-body);\n  font-size: 0.9375rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  letter-spacing: 0.01em;\n  box-shadow: 0 4px 12px rgba(26, 26, 26, 0.12);\n}\n\n.browse-button:hover {\n  background: var(--color-accent);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(212, 56, 13, 0.25);\n}\n\n.file-format-hint {\n  margin-top: 1.5rem;\n  font-size: 0.875rem;\n  color: #999;\n  font-weight: 400;\n}\n\n/* Spreadsheet Viewer Styles */\n.spreadsheet-viewer {\n  max-width: 1400px;\n  margin: 0 auto;\n  animation: fadeInUp 0.6s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.viewer-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  padding: 2rem;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px var(--color-shadow);\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.file-info {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.file-icon {\n  width: 40px;\n  height: 40px;\n  color: var(--color-accent);\n  flex-shrink: 0;\n}\n\n.file-name {\n  font-family: var(--font-display);\n  font-size: 1.5rem;\n  font-weight: 400;\n  margin-bottom: 0.25rem;\n  letter-spacing: -0.01em;\n}\n\n.sheet-count {\n  font-size: 0.875rem;\n  color: #666;\n  font-weight: 400;\n}\n\n.reset-button {\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  color: var(--color-ink);\n  border: 1.5px solid var(--color-border);\n  border-radius: 8px;\n  font-family: var(--font-body);\n  font-size: 0.9375rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  letter-spacing: 0.01em;\n}\n\n.reset-button:hover {\n  background: var(--color-ink);\n  color: white;\n  border-color: var(--color-ink);\n  transform: translateY(-1px);\n}\n\n/* Sheet Tabs */\n.sheet-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.sheet-tab {\n  padding: 0.625rem 1.25rem;\n  background: white;\n  color: #666;\n  border: 1.5px solid var(--color-border);\n  border-radius: 8px;\n  font-family: var(--font-body);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition);\n  letter-spacing: 0.01em;\n}\n\n.sheet-tab:hover {\n  background: var(--color-hover);\n  border-color: #ccc;\n}\n\n.sheet-tab.active {\n  background: var(--color-accent);\n  color: white;\n  border-color: var(--color-accent);\n  box-shadow: 0 2px 8px rgba(212, 56, 13, 0.2);\n}\n\n/* Table Container */\n.table-container {\n  background: white;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 2px 12px var(--color-shadow);\n  border: 1px solid var(--color-border);\n}\n\n.spreadsheet-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.9375rem;\n  overflow-x: auto;\n  display: block;\n}\n\n.spreadsheet-table tbody {\n  display: table;\n  width: 100%;\n}\n\n.spreadsheet-table th {\n  background: linear-gradient(180deg, #f8f8f6 0%, #f0f0ee 100%);\n  color: var(--color-ink);\n  font-family: var(--font-body);\n  font-weight: 600;\n  padding: 1rem 1.25rem;\n  text-align: left;\n  border-bottom: 2px solid var(--color-border);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  letter-spacing: 0.02em;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n}\n\n.spreadsheet-table td {\n  padding: 0.875rem 1.25rem;\n  border-bottom: 1px solid var(--color-border);\n  color: var(--color-ink);\n  font-family: var(--font-body);\n  font-weight: 400;\n  transition: background-color 0.15s ease;\n}\n\n.spreadsheet-table tr:hover td {\n  background: var(--color-hover);\n}\n\n.spreadsheet-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .excel-uploader-container {\n    padding: 2rem 1rem;\n  }\n\n  .drop-zone {\n    padding: 3rem 1.5rem;\n  }\n\n  .drop-zone-title {\n    font-size: 1.5rem;\n  }\n\n  .viewer-header {\n    padding: 1.5rem;\n  }\n\n  .file-name {\n    font-size: 1.25rem;\n  }\n\n  .spreadsheet-table th,\n  .spreadsheet-table td {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n  }\n}\n\n/* Smooth scrollbar for table */\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: var(--color-hover);\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
